import React, {Fragment} from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";
import {injectIntl} from "react-intl";

import {navItemInterface} from "../../../../interfaces/featureInterface";
import Config from "../../../../config";
import Analytics, {PRODUCT_JOURNEY_ANALYTIC_EVENTS} from "../../../../analytics";
import {updateCanvasCount} from "../../../../actions/actionFunctions";
import {ROUTES} from "../../../../routes";
import FeatureThumbnail from "../../../visComponents/featureThumbnail";
import FeatureName from "../../../visComponents/featureName";
import LookFeaturePrice from "../../lookNavigation/lookMain/lookListFeature/lookFeaturePrice";
import ShopCategoryListFeatureOptions from "./shopCategoryListFeatureOptions";
import {shopContextAction, useShopContext} from "./shopNavItemsContext";
import {getStringFeatureName} from "../../../../misc/helpers";
import FeatureDescription from "../../../visComponents/featureDescription";
import {highlightStringOnSearch} from "../../../../misc/misc2";
import {setGroheFiltersSearchText} from "../../../../actions/groheFunctions";


const ShopCategoryListFeature = (props) => {

  const {navItem, updateCanvasCount, history, isMobile, intl, filterGroups, fabricatorData, useSimpleView,
    groheFiltersSearchText, setGroheFiltersSearchText} = props;
  const feature = navItem.part;

  const {shopContextDispatch} = useShopContext();

  // const fabricatorSettings = fabricatorData.settings;
  // const showPrice = fabricatorSettings.showPricing && !fabricatorData.hideCheckoutBreakdownCost
  //   && !showPriceLocked && !fabricatorData.hidePricesFromUser;
  // const showPriceLocked = getFeatureIsLocked(feature);

  const listFeatureClick = (event) => {

    if (event.target.closest(".lk-color") || event.target.closest(".lk-feature__options")) {
      return
    }

    if (Config.isDevMode() && feature) {
      console.log("clickedShopFeature", feature);
    }

    const featureLabel = Analytics.getSkuForAnalytics(feature);
    const analyticsLabel = PRODUCT_JOURNEY_ANALYTIC_EVENTS.productFeaturesList + featureLabel;
    Analytics.sendClickEvent(analyticsLabel);

    const name = feature.dbFeature.sku || feature.dbFeature.sharedFeatureName;

    shopContextDispatch(shopContextAction({shopActiveFeature: name}))

    history.push(`${ROUTES.shop}/${feature.partId}/${name}`);
    if (groheFiltersSearchText) {
      setGroheFiltersSearchText("");
    }
    updateCanvasCount();
  }

  const collectionName = getStringFeatureName(feature, intl.messages, intl.locale, fabricatorData, filterGroups, true);
  const featureName = getStringFeatureName(feature, intl.messages, intl.locale, fabricatorData, filterGroups, false);

  // console.log("featureName", featureName);
  // console.log("collectionName", collectionName);
  // console.log("feature.dbFeature.sku", feature.dbFeature.sku);
  // console.log("====");

  if (useSimpleView) {
    return (
      <div className={"shop-list__feature shop-list__feature--simple"} onClick={listFeatureClick}>
        <div className="lm-feature__thumbnail">
          <FeatureThumbnail feature={feature}
                            lookActiveCategory={feature.partId}
                            dbFeatureId={feature.dbFeature.id}/>
        </div>
        <div className="shop-list__feature-name text-center">
          <span className="shop-list__feature-name-collection">
            <FeatureName feature={feature}/>
          </span>
        </div>
        {isMobile ? null : (
          <div className="shop-list__feature-price">
            <LookFeaturePrice lookFeature={feature} className="lm-feature__content-price"/>
          </div>
        )}
      </div>
    )
  }

  return (
    <div className={"shop-list__feature"} onClick={listFeatureClick}>
      <div className="lm-feature__thumbnail">
        <FeatureThumbnail feature={feature}
                          lookActiveCategory={feature.partId}
                          dbFeatureId={feature.dbFeature.id}/>
      </div>
      <div className="shop-list__feature-name">
        <span className="shop-list__feature-name-collection">
          <FeatureName feature={feature} useCollectionName={true} maxLength={isMobile ? 33 : 45}/>
        </span>
        {isMobile ? (
          <span className="shop-list__feature-price">
            <LookFeaturePrice lookFeature={feature} className="lm-feature__content-price"/>
          </span>
        ) : feature.dbFeature.sku && (feature.dbFeature.sku !== collectionName) ? (
          <span className="shop-list__feature-name-model">
            {highlightStringOnSearch(feature.dbFeature.sku, groheFiltersSearchText)}
          </span>
        ) : null}
      </div>
      {isMobile ? null : (
        <Fragment>
          {(featureName !== collectionName) && (!feature.dbFeature.sku || (featureName !== feature.dbFeature.sku)) ? (
            <p className="lm-feature__content-description">
              <FeatureName feature={feature} maxLength={70}/>
            </p>
          ) : (feature.dbFeature.description && (feature.dbFeature.description !== collectionName))
            ? <FeatureDescription className="lm-feature__content-description"
                                                                  feature={feature}
                                                                  brief={true}
                                                                  textLength={70}/>
            : <p className="lm-feature__content-description"/>}
          <div className="shop-list__feature-price">
            <LookFeaturePrice lookFeature={feature} className="lm-feature__content-price"/>
          </div>
          <div className="shop-list__feature-options">
            <ShopCategoryListFeatureOptions navItem={navItem}/>
          </div>
        </Fragment>
      )}
    </div>
  )
};

ShopCategoryListFeature.propTypes = {
  navItem: PropTypes.shape(navItemInterface),
  featureGroup: PropTypes.object,
  updateLookCartItem: PropTypes.func,
  useSimpleView: PropTypes.bool,
}

const mapStateToProps = (store) => {
  const {isMobile} = store.serverState;

  const fabricatorData = store.fabricatorState;
  const {isPhoneNumberValidated} = store.userState; // to update component when user is logged in
  const {filterGroups} = store.filterState;
  const {groheFiltersSearchText} = store.groheState;

  return {
    isMobile,
    fabricatorData,
    isPhoneNumberValidated,
    filterGroups,
    groheFiltersSearchText,
  };
};

const mapDispatchToProps = {
  updateCanvasCount,
  setGroheFiltersSearchText,
};

export default injectIntl(
  withRouter(
    connect(mapStateToProps, mapDispatchToProps)(ShopCategoryListFeature)
  )
)
